export const setupResizer = (): void => {
  const head = document.getElementsByTagName("head")[0]
  const script = document.createElement("script")
  script.type = "text/javascript"
  script.src = "https://files.newsnetz.ch/scripts/dimension_watcher.js"
  head.appendChild(script)

  script.onload = () => {
    const app = document.getElementById("app")

    if (app !== null && typeof DimensionWatcher !== "undefined") {
      // Initialise Dimensionwatcher
      /** Calculate the height of the app element */
      const getHeight = () => Math.ceil(app.getBoundingClientRect().height)

      DimensionWatcher.enableParentNotification(
        // width is always 100%
        () => "100%",
        getHeight
      )

      // Initialise AMP
      /** broadcast the height back to AMP */
      const ampSizeBroadcast = () => {
        window.parent.postMessage(
          {
            sentinel: "amp",
            type: "embed-size",
            height: getHeight()
          },
          "*"
        )
      }
      // Brute-force method – broadcast the height every second, just
      // to be sure.
      setInterval(ampSizeBroadcast, 1000)

    } else {
      // http://i0.kym-cdn.com/photos/images/original/001/142/233/897.gif
      // (finding nemo now what)
    }
  }
}
